import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-slides-sales-card',
  templateUrl: 'sales-card.component.html'
})
export class SlidesSalesCardComponent {
  @Input() item: any = {};
  @Input() setting: any;

  constructor(
  ) {
  }

}
